import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import Header from "./Sections/Header/Header.jsx";
import Footer from "./Sections/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "./Sections/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
// import ProductSection from "./Sections/ProductSection.jsx";
import TeamSection from "./Sections/TeamSection.jsx";
// import WorkSection from "./Sections/WorkSection.jsx";

import ProductCategories from "views/ProductCategories";
import SectionCarousel from "./Sections/SectionCarousel.jsx";
// import NaniTable from "../NaniTable/NaniTable.js";

import NaniTableTabs from "../NaniTableTabs/NaniTableTabs.js";

import Card from "components/Card/Card.jsx";





var topImg = "https://cdn.nani.cool/web/onegrade/img/Top.png";

const dashboardRoutes = [];

class HomePage extends React.Component {

  render() {

    const { classes, dataType, selectTab, changeLoginType, naniEditData, naniLogout, tableBtnToTabData, selectTableTab, tableBtnClassResult, tableBtnNaniAnswerAnalysis,downloadTestPaperAllClass, ...rest } = this.props;
    // [{ "Name": "南一書局", "ID": "1", "TAB": "Home" }, { "Name": "南一報表", "ID": "2", "TAB": "Table" }]
    var linkBtnData = [
      { "Type":"Image" ,"Name":"IMG", "LINK":"https://onegrade.oneclass.com.tw/img/onegrade_s@2x.png", "ID": "0", "TAB": "Home", "DIV": "TOP" ,"MOBILE":true},
      // { "Name": "OneGrade 閱卷專家", "ID": "0", "TAB": "Home", "DIV": "TOP" ,"MOBILE":true},
     { "Type":"Button","Name": "APP下載", "ID": "1", "TAB": "Home", "DIV": "TOP","MOBILE":false },
     { "Type":"Button", "Name": "使用說明", "ID": "2", "TAB": "Home", "DIV": "InstructionsForUse","MOBILE":false },
     { "Type":"Button", "Name": "實用特色", "ID": "3", "TAB": "Home", "DIV": "PracticalFeatures" ,"MOBILE":false},
     { "Type":"Button", "Name": "下載國中小答案卡", "ID": "4", "TAB": "Home", "DIV": "","MOBILE":false ,"LINK":"https://cdn.nani.cool/app/OneGrade_ans.pdf"},
     { "Type":"Button", "Name": "下載高中答案卡", "ID": "5", "TAB": "Home", "DIV": "","MOBILE":false ,"LINK":"https://cdn.nani.cool/app/OneGrade_ans1.pdf"},
     { "Type":"Button", "Name": "線上成績系統", "ID": "6", "TAB": "Table", "DIV": "","MOBILE":false }
    
    ];
    //     APPDownload
    // InstructionsForUse
    // PracticalFeatures
    // const rightLinksData =(<HeaderLinks  dataType={dataType} changeLoginType={changeLoginType}/>);
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="OneGrade"
          brands={linkBtnData}
          brandSelect="1"
          dataType={dataType}
          // isLogin={isLogin}
          selectTab={selectTab}
          changeLoginType={changeLoginType}
          // Comment={this.selectTab.bind(this)}
          // ChangeLogin={this.changeLoginType.bind(this)}
          rightLinks={<HeaderLinks brands={linkBtnData} dataType={dataType} changeLoginType={changeLoginType} naniEditData={naniEditData} naniLogout={naniLogout} />}
          fixed
          changeColorOnScroll={{
            height: 100,
            color: "gray"
          }}
          {...rest}
        />

        {/* <Parallax filter image={require("https://cdn.nani.cool/web/onegrade/img/top.png")} style={ ( dataType.currentTab!=="Home") ? {height:"200px"} :{}}>  */}
        <Parallax id={linkBtnData[0].DIV} filter image={topImg} style={(dataType.currentTab !== "Home") ? { height: "200px" } : { height: "1200px" }}>
          <div className={classes.container} style={{ display: (dataType.currentTab === "Home") ? 'block' : 'none' }}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>把時間還給教學</h1>
                <h1 className={classes.title}>考卷的事交給OneGrade 閱卷專家</h1>


                
                <GridContainer>

          
                <GridItem xs={6} sm={6} md={6} >
                <img src="img/android_qr.png" alt="..."  style={{width:'150px'}}/>
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                <img src="img/ios_qr.png" alt="..."  style={{width:'150px'}}/>
                </GridItem>
                <GridItem xs={6} sm={6} md={6} >
                <a href="https://play.google.com/store/apps/details?id=com.nani.CorrectCheck" target="_blank">
                <img src="img/android.png" alt="..."  style={{width:'150px'}}/>
                </a>
                </GridItem>

                <GridItem xs={6} sm={6} md={6} >
                <a href="https://itunes.apple.com/tw/app/onegrade/id1446847858?l=zh&ls=1&mt=8" target="_blank">
                <img src="img/ios.svg" alt="..."  style={{width:'150px' ,padding:'5px 15px '}}/>
                </a>
                </GridItem>
             
            </GridContainer>                   
                {/* <h4>
                <a href="https://play.google.com/store/apps/details?id=com.nani.CorrectCheck" ><Button size="lg"><i class="fab fa-android"></i>Android</Button></a>
                  <a href="https://itunes.apple.com/tw/app/onegrade/id1446847858?l=zh&ls=1&mt=8"><Button size="lg"><i class="fab fa-apple"></i>APPLE</Button></a>
                </h4>*/}
                <h4> 
                <a href="https://cdn.nani.cool/app/OneGrade_ans.pdf" target="_blank"><Button size="sm">答案卡</Button></a>
                </h4>
              </GridItem>
         
            </GridContainer>
          </div>
        </Parallax>
        <div id="TabHome" style={{ display: (dataType.currentTab === "Home") ? 'block' : 'none' }} >
          <div className={classNames(classes.main, classes.mainRaised)} >
            <div className={classes.container}>
              {/* <ProductSection /> */}
              {/* <ProductCategories /> */}
              <TeamSection linkBtnData={linkBtnData} />
              {/* <SectionCarousel/> */}
              {/* <WorkSection /> */}
            </div>
          </div>
        </div>
        <div id="TabTable" style={{ display: (dataType.currentTab === "Table") ? 'block' : 'none' }}>
          <div className={classNames(classes.main, classes.mainRaised)}>
            <div className={classes.container}>
              <NaniTableTabs dataType={dataType} tableBtnToTabData={tableBtnToTabData} selectTableTab={selectTableTab} tableBtnClassResult={tableBtnClassResult} tableBtnNaniAnswerAnalysis={tableBtnNaniAnswerAnalysis} downloadTestPaperAllClass={downloadTestPaperAllClass} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(HomePage);



// WEBPACK FOOTER //
// ./src/views/HomePage/HomePage.jsx